import { Navigate } from "react-router-dom";
import { LoadingSpinner } from "@/core/components/loading-spinner";
import { Card } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack/stack";
import { useBusiness } from "@/core/business";

const BusinessSettingsRedirect = () => {
  const { businessId, isLoading } = useBusiness();

  if (isLoading) {
    return (
      <Stack fullWidth className="h-full px-6 py-8">
        <Card className="flex h-full w-full items-center justify-center overflow-auto p-6">
          <LoadingSpinner flexHeight />
        </Card>
      </Stack>
    );
  }

  if (!businessId) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to={`/business-settings/${businessId}`} replace />;
};

export default BusinessSettingsRedirect;
